// extracted by mini-css-extract-plugin
module.exports = {"alertMsg":"homepage_alertMsg__2-b8A","carousel":"homepage_carousel__QHnTO","slickslide":"homepage_slickslide__l3XFs"};